import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import config from '../../config'
import Social from '../assets/images/meta.png'
import '../assets/sass/main.scss'
import Footer from './Footer'
import Header from './Header'

interface LayoutProps {
  title?: string
  titleOverride?: string // full title without the "| Swarmia" in the end
  description?: string
  justifyCenter?: boolean
  hideNavigation?: boolean
  children: React.ReactNode
  noIndex?: boolean
  metaImage?: string
  variant?: 'dark' | 'light'
  isNew?: boolean
}

interface LayoutState {
  isPreloaded: boolean
}

class Layout extends Component<LayoutProps, LayoutState> {
  constructor(props: LayoutProps) {
    super(props)
    this.state = {
      isPreloaded: true,
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isPreloaded: false })
    }, 100)
  }

  render() {
    const {
      title,
      titleOverride,
      description,
      children,
      justifyCenter,
      hideNavigation,
      noIndex,
      metaImage,
      variant,
      isNew,
    } = this.props
    const { isPreloaded } = this.state
    const divClassName = [
      'main-body',
      isNew ? 'main-body-new-styles' : 'main-body-old-styles',
      isPreloaded ? 'is-preload' : null,
      justifyCenter ? 'justify-center' : null,
    ]
      .filter(element => !!element)
      .join(' ')
    const helmetBodyAttributes = justifyCenter
      ? { class: 'justify-center' }
      : undefined
    const image = 'https://www.swarmia.com' + (metaImage || Social)
    const siteTitle = titleOverride ?? `${title || config.siteTitle} | Swarmia`
    const siteDescription = description || ''
    return (
      <>
        <Helmet title={siteTitle} bodyAttributes={helmetBodyAttributes}>
          <html lang="en" />
          <meta name="description" content={siteDescription} />
          <meta name="image" content={image} />

          <meta property="og:title" content={siteTitle} />
          <meta property="og:description" content={siteDescription} />
          <meta
            property="keywords"
            content="Software engineering metrics, engineering leadership metrics, cycle time, Slack integration, GitHub integration, pull request notifications, code review companies, analytics, management in software engineering, git statistics, engineering productivity metrics, code review metrics, GitHub pull request dashboard"
          />
          <meta property="og:image" content={image} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image" content={image} />
          <meta name="twitter:title" content={siteTitle} />
          <meta name="twitter:description" content={siteDescription} />
          {variant === 'dark' ? (
            <meta name="theme-color" content="#030b24" />
          ) : null}
          {noIndex && <meta name="robots" content="noindex" />}
          <script
            async
            src="https://www.google.com/recaptcha/api.js?render=6LcuiCEqAAAAAIq31g0fnnwjrgttihtdAydVmMS8"
          />
          <script>{`
            (function () {
              function getCookie(name) {
                const value = '; ' + document.cookie;
                const parts = value.split('; ' + name + '=');
                if (parts.length === 2) return parts.pop().split(';').shift();
                return null;
              }
              const faCookie = atob(getCookie('_fuid'));
              if (faCookie) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  'event': 'factorsUserIdTrack',
                  'userId': faCookie
                });
              }
            })();
            `}</script>
        </Helmet>
        <MainContentWrapper className={divClassName}>
          {!hideNavigation && <Header variant={variant} />}
          {children}
        </MainContentWrapper>
        {!hideNavigation && <Footer />}
      </>
    )
  }
}

const MainContentWrapper = styled.div`
  min-height: calc(100vh - 399px); // 100vh - Footer height
`

export default Layout
